export default "__VITE_ASSET__Cq7l7uNO__"